import { isPlatformBrowser, Location } from '@angular/common';
import { Component, Inject, OnDestroy, OnInit, PLATFORM_ID } from '@angular/core';
import { AngularFireAnalytics } from '@angular/fire/analytics';
import { AngularFireAuth} from '@angular/fire/auth';
import { AngularFirestore } from '@angular/fire/firestore';
import { ActivatedRoute, ActivationStart, NavigationEnd, Router } from '@angular/router';
import { Subscription } from 'rxjs';
import { filter } from 'rxjs/operators';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css']
})
export class AppComponent implements OnInit, OnDestroy {
  title = 'CursosPredyc';
  subscription: Subscription;
  mostrarMenu = 1;
  mostrarChat = 0;
  // router: string;
  token: string;

  constructor(@Inject(PLATFORM_ID) private platformId: Object, private router: Router, private route: ActivatedRoute, 
    private afAuth: AngularFireAuth,
    private afs: AngularFirestore,
    public analytics: AngularFireAnalytics) {
      analytics.logEvent('custom_event')
    // this.router = _router.url;
    // console.log('this.router')
    // console.log(this.router)
  }

  ngOnInit() {
    this.afAuth.onAuthStateChanged(user => {
      if (user) {
        user.getIdTokenResult().then(idTokenResult => {
          const token = idTokenResult.claims.claim;
          this.token = token;
          if (token){
            localStorage.setItem('token', JSON.stringify(token));
          } else {
            localStorage.setItem('token', null);
          }
          if (token != 'instructor') {
            if (token == 'estudiante' || token == 'superadmin' || token == 'editor' || token == 'administrador') {
              this.afs.collection('usuarios').doc(user.uid).ref.get().then((snap) => {
                const user = snap.data();
                localStorage.setItem('user', JSON.stringify(user));
              }).catch((error) => {
                console.log(error);
              })
            } else {
              localStorage.setItem('user', null);
            }           
          } else {
            this.afs.collection('usuariosInstructor').doc(user.uid).ref.get().then((snap) => {
              const user = snap.data();
              localStorage.setItem('user', JSON.stringify(user));
            }).catch((error) => {
              console.log(error);
            })
          }
        })
      } else {
        localStorage.setItem('user', null);
        localStorage.setItem('token', null);
      }
    })

    this.subscription = this.router.events.pipe(
      filter(event => event instanceof NavigationEnd)
    ).subscribe(() => {
      if (isPlatformBrowser(this.platformId)) {
        window.scroll(0, 0);
      }
      this.mostrarMenu = 1
      let Url = this.router.routerState.snapshot.url.split('/')
      for (let i = 0; i < Url.length; i++) {
        if( Url[i] == 'modulo' || Url[i] == 'admin' || Url[i] == '403') {
          this.mostrarMenu = 0
        }
      }
    })
    document.documentElement.setAttribute('data-theme', 'light');
  }

  ngOnDestroy() {

  }

  cerrarChat(valueEmitted){
    this.mostrarChat = valueEmitted;
  }



}
